import { render, staticRenderFns } from "./InventoryTypes.vue?vue&type=template&id=59ab1450&scoped=true"
import script from "./InventoryTypes.vue?vue&type=script&lang=js"
export * from "./InventoryTypes.vue?vue&type=script&lang=js"
import style0 from "./InventoryTypes.vue?vue&type=style&index=0&id=59ab1450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ab1450",
  null
  
)

export default component.exports